import { LoaderCircle } from "lucide-react";

const Spinner = ({ styles, ...rest }) => {
  return <LoaderCircle className={`animate-spin ${styles}`} {...rest} />;
};

export default Spinner;
